<div class="card-container mat-elevation-z1">
    <div class="card-content">
        <div class="margin-botton-medium">
            <h4>Turnos reservados</h4>
            <mat-divider></mat-divider>
            <mat-spinner *ngIf="loading"></mat-spinner>
            <div class="grid-scroll-container" *ngIf="!loading">
                <p-table class="search-table" [value]="pendingDataSource" [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }">
                    <ng-template pTemplate="header">
                        <tr class="search-table-header">
                            <th class="resizable-header" *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)" (dragover)="onHeaderDragOver($event)" (drop)="onHeaderDrop($event, col.field)">
                                <div class="header-top-row">
                                    <span class="header-drag-content">
                    <span class="column-title" (click)="sortByColumn('pending', col.field)">
                      {{ col.title }}
                      <mat-icon class="sort-icon">{{ getSortIcon('pending', col.field) }}</mat-icon>
                    </span>
                                    <mat-icon class="header-drag-handle" draggable="true" (dragstart)="onHeaderDragStart($event, col.field)" (dragend)="onHeaderDragEnd()" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                                    </span>
                                    <span class="column-resize-handle" (mousedown)="startResize($event, col.field)"></span>
                                </div>
                                <input class="column-filter-input" [value]="pendingColumnFilters[col.field] || ''" (click)="$event.stopPropagation()" (input)="onColumnFilterInput('pending', col.field, $event.target.value)" placeholder="Filtrar" />
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-element>
                        <tr class="search-table-cell">
                            <td *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)">
                                {{ formatCellValue(element, col.field) }}
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="orderedColumnsDefinition.length">
                                <b>No existen turnos reservados</b>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        <div class="margin-botton-medium">
            <h4>Turnos realizados</h4>
            <mat-divider></mat-divider>
            <mat-spinner *ngIf="loading"></mat-spinner>
            <div class="grid-scroll-container" *ngIf="!loading">
                <p-table class="search-table" [value]="madeDataSource" [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }">
                    <ng-template pTemplate="header">
                        <tr class="search-table-header">
                            <th class="resizable-header" *ngFor="let col of orderedMadeColumnsDefinition" [style.width.px]="getColumnWidth(col.field)" (dragover)="onHeaderDragOver($event)" (drop)="onMadeHeaderDrop($event, col.field)">
                                <div class="header-top-row">
                                    <span class="header-drag-content">
                    <span class="column-title" (click)="sortByColumn('made', col.field)">
                      {{ col.title }}
                      <mat-icon class="sort-icon">{{ getSortIcon('made', col.field) }}</mat-icon>
                    </span>
                                    <mat-icon class="header-drag-handle" draggable="true" (dragstart)="onHeaderDragStart($event, col.field)" (dragend)="onHeaderDragEnd()" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                                    </span>
                                    <span class="column-resize-handle" (mousedown)="startResize($event, col.field)"></span>
                                </div>
                                <input class="column-filter-input" [value]="madeColumnFilters[col.field] || ''" (click)="$event.stopPropagation()" (input)="onColumnFilterInput('made', col.field, $event.target.value)" placeholder="Filtrar" />
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-element>
                        <tr class="search-table-cell">
                            <td *ngFor="let col of orderedMadeColumnsDefinition" [style.width.px]="getColumnWidth(col.field)">
                                {{ formatCellValue(element, col.field) }}
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="orderedMadeColumnsDefinition.length">
                                <b>No existen turnos realizados</b>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        <div class="margin-botton-medium">
            <h4>Turnos inconsistentes</h4>
            <mat-divider></mat-divider>
            <mat-spinner *ngIf="loading"></mat-spinner>
            <div class="grid-scroll-container" *ngIf="!loading">
                <p-table class="search-table" [value]="inconsistentDataSource" [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }">
                    <ng-template pTemplate="header">
                        <tr class="search-table-header">
                            <th class="resizable-header" *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)" (dragover)="onHeaderDragOver($event)" (drop)="onHeaderDrop($event, col.field)">
                                <div class="header-top-row">
                                    <span class="header-drag-content">
                    <span class="column-title" (click)="sortByColumn('inconsistent', col.field)">
                      {{ col.title }}
                      <mat-icon class="sort-icon">{{ getSortIcon('inconsistent', col.field) }}</mat-icon>
                    </span>
                                    <mat-icon class="header-drag-handle" draggable="true" (dragstart)="onHeaderDragStart($event, col.field)" (dragend)="onHeaderDragEnd()" (click)="$event.stopPropagation()">drag_indicator</mat-icon>
                                    </span>
                                    <span class="column-resize-handle" (mousedown)="startResize($event, col.field)"></span>
                                </div>
                                <input class="column-filter-input" [value]="inconsistentColumnFilters[col.field] || ''" (click)="$event.stopPropagation()" (input)="onColumnFilterInput('inconsistent', col.field, $event.target.value)" placeholder="Filtrar" />
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-element>
                        <tr class="search-table-cell">
                            <td *ngFor="let col of orderedColumnsDefinition" [style.width.px]="getColumnWidth(col.field)">
                                {{ formatCellValue(element, col.field) }}
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="orderedColumnsDefinition.length">
                                <b>No existen turnos inconsistentes</b>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
